module.exports = __webpack_public_path__ + "assets/06e80cb4ce22ca912a227d385348e7d8.png";